import Radium from '@flipdish/radium';
import axios from 'axios';
import { Dialog, DialogTitle } from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core';
import * as Raven from 'raven-js';
import * as React from 'react';
import * as Api from '../../Api';
import * as Data from '../../Data';
import { Utilities } from '../../Utilities';
const tinycolor = require('tinycolor2');

interface Props {
  AppConfig: Data.Async<Api.AppConfig>;
  ShowEmailModal: boolean;
  Close: () => any;
  EmailRequestMode: number;
  isDark: boolean;
  translate: any;
  UpdateCustomer: () => any;
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {
  email: string;
}

const DialogContent = withStyles(
  {
    root: {
      padding: '16px 16px'
    }
  },
  { name: 'FdDialogContent' }
)(MuiDialogContent);

const DialogActions = withStyles(
  {
    root: {
      padding: '8px 16px 16px',
      display: 'inherit'
    }
  },
  { name: 'FdDialogActions' }
)(MuiDialogActions);

class EmailModal extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    this.state = {
      email: ''
    };
  }

  public handleEmailChange = (event: any) => {
    this.setState({ email: event.target.value });
  };

  public handleKeyPress = (target: any) => {
    // Handle Enter
    if (target.charCode === 13) {
      this.handleEmailSubmit();
    }
  };

  public handleDismissModal = () => {
    localStorage.setItem('dismissedModal', 'true');
    this.props.Close();
  };

  public handleEmailSubmit = () => {
    if (this.state.email === '') {
      return;
    }

    const ifSubmitFails = (error: any) => {
      let appconfig: any = {};

      if (this.props.AppConfig.status === 'success') {
        appconfig.AppNameId = this.props.AppConfig.data.AppNameId;
        appconfig.WhiteLabelId = this.props.AppConfig.data.WhiteLabelId;
      }

      Raven.captureMessage('Submit email failed', {
        tags: { category: 'API failure' },
        extra: {
          error: Utilities.handleError(error),
          appconfig: appconfig,
          email: this.state.email
        }
      });
    };

    const xhr = axios.post(
      '/Account/SetEmailAddress',
      {
        Email: this.state.email
      },
      { withCredentials: true }
    );

    xhr
      .then((e) => {
        const r: Api.Result<any> = e.data;

        if (!r.Success) {
          alert(r.UserMessage);
          ifSubmitFails(r);
        } else {
          this.setState({ email: '' });
          this.props.Close();
          this.props.UpdateCustomer();
        }
      })
      .catch((err) => {
        const r: Api.Result<any> = err.response.data;

        if (!r.Success) {
          alert(r.UserMessage);
          ifSubmitFails(r);
        }
      });
  };

  public render(): JSX.Element {
    const { translate, AppDesignScheme } = this.props;
    const offset: string | null = Utilities.extraOption('data-offset');
    const dismissedModal =
      localStorage.getItem('dismissedModal') === 'true' &&
      this.props.EmailRequestMode === Api.EmailRequestMode.Request;
    let emailModalTitle = null;
    let emailModalButtons = null;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      formControl: {
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      formControlDarkTheme: {
        backgroundColor: tinycolor(AppDesignScheme.Tertiary),
        color: tinycolor(AppDesignScheme.Primary),
        borderColor: tinycolor(AppDesignScheme.Primary)
          .setAlpha(0.2)
          .toString(),
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      }
    };

    switch (this.props.EmailRequestMode) {
      case Api.EmailRequestMode.Require:
        emailModalTitle = translate('We_need_your_email_address_to_process_your_order');
        emailModalButtons = (
          <div className="flex flex-align-center flex-justify-center">
            <button
              className="fd-button fd-button--secondary fd-button--big"
              disabled={!Utilities.isValidEmail(this.state.email)}
              onClick={this.handleEmailSubmit}
              key="submit-button"
              style={
                [
                  styles.buttonSecondary,
                  Radium.getState(this.state, 'submit-button', ':active')
                    ? styles.buttonActive
                    : Radium.getState(this.state, 'submit-button', ':hover')
                    ? styles.buttonHover
                    : null
                ] as any
              }
            >
              <h4 className="clear-margins primary" style={styles.primary}>
                {translate('Submit')}
              </h4>
            </button>
          </div>
        );
        break;
      default:
        emailModalTitle = translate('Please_enter_your_email_address');
        emailModalButtons = (
          <div className="flex flex-align-center flex-justify-between email-modal--request">
            <button
              className="fd-button fd-button--secondary flex-one"
              onClick={() => this.handleDismissModal()}
              key="reject-button"
              style={
                [
                  styles.buttonSecondary,
                  Radium.getState(this.state, 'reject-button', ':active')
                    ? styles.buttonActive
                    : Radium.getState(this.state, 'reject-button', ':hover')
                    ? styles.buttonHover
                    : null
                ] as any
              }
            >
              <h4 className="clear-margins primary" style={styles.primary}>
                {translate('No_thanks')}
              </h4>
            </button>
            <button
              className="fd-button fd-button--secondary flex-one"
              disabled={!Utilities.isValidEmail(this.state.email)}
              onClick={this.handleEmailSubmit}
              key="submit-button"
              style={
                [
                  styles.buttonSecondary,
                  Radium.getState(this.state, 'submit-button', ':active')
                    ? styles.buttonActive
                    : Radium.getState(this.state, 'submit-button', ':hover')
                    ? styles.buttonHover
                    : null
                ] as any
              }
            >
              <h4 className="clear-margins primary" style={styles.primary}>
                {translate('Submit')}
              </h4>
            </button>
          </div>
        );
        break;
    }

    return (
      <Dialog
        open={this.props.ShowEmailModal && !dismissedModal}
        style={{ marginTop: isNaN(parseInt(offset)) ? 0 : parseInt(offset) }}
        className={`email-modal ${this.props.isDark ? 'email-modal--dark' : ''}`}
      >
        <div className="email-modal__container">
          <DialogTitle
            disableTypography
            tabIndex={0}
            className="email-modal__title"
            style={this.props.isDark ? styles.primary : styles.tertiary}
          >
            {emailModalTitle}
          </DialogTitle>
          <DialogContent>
            <input
              aria-label={`${translate('Please_enter_your_email_address')}`}
              key="email-input"
              autoFocus
              className="form-control"
              onKeyPress={this.handleKeyPress}
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleEmailChange}
              type="email"
              style={this.props.isDark ? styles.formControlDarkTheme : styles.formControl}
            />
          </DialogContent>
          <DialogActions>{emailModalButtons}</DialogActions>
        </div>
      </Dialog>
    );
  }
}

export default Radium(EmailModal);
